// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingCollage_container__p59-N","loading":"LoadingCollage_loading__2Z99h"};